<template>
  <div class="page-container">
    <div class="title_area">
      <div class="logo_area">
        <img class="logo_img" alt="testar_logo" src="../../assets/logo.png">
      </div>
      <div class="text_area">
        <span class="text_title">特星球</span>
        <span class="sub_text_title">特斯拉车主专属的星球，一起分享你”特”别的每天一天。</span>
      </div>
    </div>

    <!-- swiper -->
    <div class="swiper_area">
      <swiper class="swiper"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :options="swiperOption">
        <swiper-slide><img class="swiper_img" src="../../assets/bg.jpg" alt="" mode="aspectFill"></swiper-slide>
        <swiper-slide><img class="swiper_img" src="../../assets/1.jpeg" alt="" mode="aspectFill"></swiper-slide>
        <swiper-slide><img class="swiper_img" src="../../assets/2.jpeg" alt="" mode="aspectFill"></swiper-slide>
        <swiper-slide><img class="swiper_img" src="../../assets/3.jpeg" alt="" mode="aspectFill"></swiper-slide>
        <swiper-slide><img class="swiper_img" src="../../assets/bg2.jpg" alt="" mode="aspectFill"></swiper-slide>
      </swiper>

      <span class="sub_text">特星球TESTARS品牌成立于深圳，是一家专注于智能新能源车品研发和设计的公司，核心团队由一帮玩车的极客组成。<br />致力于打造全新的人-车智能互联网生态，通过特星球一系列智能产品与AI的结合，不仅能让车内座舱变为一个智能物联网空间，更能让世界各地的车友智能互联，共建一个专属的车友“星球”。</span>
    </div>
  </div>

</template>

<script>
import 'swiper/swiper-bundle.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      swiperOption: {
        // 设置slider容器能够同时显示的slides数量(carousel模式)
        slidesPerView: 2,
        // 设定为true时，active slide会居中，而不是默认状态下的居左(false)
        centeredSlides: true,
        // 滑动速度
        speed: 1500,
        // 在slide之间设置距离（单位px）
        spaceBetween: 10,
        // 设定初始化时slide的索引，Swiper默认初始化时显示第一个slide
        initialSlide: 0,
        // 循环播放
        loop: true,
        // 自动播放
        autoplay: {
          // 隔×秒自动滑动一次
          delay: 800,
          // 设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay。默认为true
          disableOnInteraction: false,
        },
        // 标记页数
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许分页点击跳转
        },
        // 左右箭头
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  mounted() {
  },
  methods: {
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  }
}
</script>

<style>

.title_area {
  width: 100%;
  background-color: #161617;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 32px 0 24px;
}

.text_title {
  font-size: 30px;
  color: #E8E8ED;
  margin-bottom: 12px;
}

.sub_text_title {
  font-size: 15px;
  color: #E8E8ED;
  margin-bottom: 12px;
}

.sub_text {
  font-size: 10px;
  color: #E8E8ED;
  text-align: center;
  margin: 32px 0 0;
  line-height: 18px;
}

.logo_area {
  width: 150px;
  margin: 0 0 16px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.logo_img {
  width: 250px;
  border-radius: 25px;
}


.text_area {
  width: 100%;
  background-color: #161617;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.swiper_area {
  width: 100%;
  height: 450px;
  background-color: #161617;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  padding-bottom: 64px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>
